import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/policy-violations/{-$id}')({
  beforeLoad: () => getTitleContextSlice('Policy Violations'),
  staticData: {
    owner: CodeOwner.Assets,
  },
});
